import React, { Component } from 'react'
import { connect } from 'react-redux'

class CurrencyCodes extends Component {
    renderIntegrationTool() {
        return null
    }

    renderDocument() {
        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Currency Codes</b></span>
                <div style={{margin: '1vw'}}>
                    <span style={{marginRight: '0.5vw'}}>For currency symbols, see</span>
                    <a href="https://justforex.com/education/currencies">https://justforex.com/education/currencies</a>
                </div>
                <p className="note" style={{width: '50vw', margin: '2vw'}}><b>NOTE: </b> This documentation contains links to websites owned and operated by third parties.
                                                If you use these links, you leave our website. These links are provided for your information
                                                and convenience only and are not an endorsement by Moneris Solutions of the content of
                                                such linked websites or third parties. Moneris Solutions has no control over the contents of
                                                any linked website and is not responsible for these websites or their content or availability. If
                                                you decide to access any third party websites and make use of the information contained on
                                                them, you do so entirely at your own risk.</p>

                <table>
                    <th>Numeric Currency Code (ISO)</th>
                    <th>Currency Name/Acronym</th>

                    <tr>
                        <td>008</td>
                        <td>Albanian Lek (ALL)</td>
                    </tr>
                    <tr>
                        <td>012</td>
                        <td>Algerian Dinar (DZD)</td>
                    </tr>
                    <tr>
                        <td>032</td>
                        <td>Argentine Peso (ARS)</td>
                    </tr>
                    <tr>
                        <td>036</td>
                        <td>Australian Dollar (AUD)</td>
                    </tr>
                    <tr>
                        <td>048</td>
                        <td>Bahraini Dinar (BHD)</td>
                    </tr>
                    <tr>
                        <td>050</td>
                        <td>Bangladeshi Taka (BDT)</td>
                    </tr>
                    <tr>
                        <td>052</td>
                        <td>Barbados Dollar (BBD)</td>
                    </tr>
                    <tr>
                        <td>060</td>
                        <td>Bermudian Dollar (BMD)</td>
                    </tr>
                    <tr>
                        <td>064</td>
                        <td>Bhutan Ngultrum (BTN)</td>
                    </tr>
                    <tr>
                        <td>068</td>
                        <td>Bolivia Boliviano (BOB)</td>
                    </tr>
                    <tr>
                        <td>084</td>
                        <td>Belize Dollar (BZD)</td>
                    </tr>
                    <tr>
                        <td>090</td>
                        <td>Solomon Islands Dollar (SBD)</td>
                    </tr>
                    <tr>
                        <td>096</td>
                        <td>Brunei Dollar (BND)</td>
                    </tr>


                    <tr>
                        <td>108</td>
                        <td>Burundi Franc (BIF)</td>
                    </tr>
                    <tr>
                        <td>132</td>
                        <td>Cabo Verde Escudo (CVE)</td>
                    </tr>
                    <tr>
                        <td>136</td>
                        <td>Cayman Islands Dollar (KYD)</td>
                    </tr>
                    <tr>
                        <td>144</td>
                        <td>Sri Lanka Rupee (LKR)</td>
                    </tr>
                    <tr>
                        <td>152</td>
                        <td>Chilean Peso (CLP)</td>
                    </tr>
                    <tr>
                        <td>156</td>
                        <td>Chinese Yuan (CNY)</td>
                    </tr>
                    <tr>
                        <td>170</td>
                        <td>Colombian Peso (COP)</td>
                    </tr>
                    <tr>
                        <td>174</td>
                        <td>Comorian Franc (KMF)</td>
                    </tr>
                    <tr>
                        <td>188</td>
                        <td>Costa Rican Colon (CRC)</td>
                    </tr>
                    <tr>
                        <td>191</td>
                        <td>Croatian Kuna (HRK)</td>
                    </tr>
                    <tr>
                        <td>192</td>
                        <td>Cuban Peso (CUP)</td>
                    </tr>
                    <tr>
                        <td>203</td>
                        <td>Czech Koruna (CZK)</td>
                    </tr>
                    <tr>
                        <td>208</td>
                        <td>Danish Krone (DKK)</td>
                    </tr>
                    <tr>
                        <td>214</td>
                        <td>Dominican Republic Peso</td>
                    </tr>
                    <tr>
                        <td>222</td>
                        <td>Salvadoran Colon (SVC)</td>
                    </tr>
                    <tr>
                        <td>242</td>
                        <td>Fijian Dollar (FJD)</td>
                    </tr>
                    <tr>
                        <td>262</td>
                        <td>Djiboutian Franc (DJF)</td>
                    </tr>
                    <tr>
                        <td>270</td>
                        <td>Gambian Dalasi (GMD)</td>
                    </tr>
                    <tr>
                        <td>292</td>
                        <td>Gibraltar Pound (GIP)</td>
                    </tr>
                    <tr>
                        <td>320</td>
                        <td>Guatemala Quetzal (GTQ)</td>
                    </tr>
                    <tr>
                        <td>324</td>
                        <td>Guinean Franc (GNF)</td>
                    </tr>
                    <tr>
                        <td>328</td>
                        <td>Guyanese Dollar (GYD)</td>
                    </tr>
                    <tr>
                        <td>332</td>
                        <td>Haitian Gourde (HTG)</td>
                    </tr>
                    

                    <tr>
                        <td>340</td>
                        <td>Honduran Lempira (HNL)</td>
                    </tr>
                    <tr>
                        <td>344</td>
                        <td>Hong Kong Dollar (HKD)</td>
                    </tr>
                    <tr>
                        <td>348</td>
                        <td>Hungarian Forint (HUF)</td>
                    </tr>
                    <tr>
                        <td>352</td>
                        <td>Iceland Krona (ISK)</td>
                    </tr>
                    <tr>
                        <td>356</td>
                        <td>Indian Rupee (INR)</td>
                    </tr>
                    <tr>
                        <td>360</td>
                        <td>Indonesian Rupiah (IDR)</td>
                    </tr>
                    <tr>
                        <td>376</td>
                        <td>Israeli Shekel (ILS)</td>
                    </tr>
                    <tr>
                        <td>388</td>
                        <td>Jamaican Dollar (JMD)</td>
                    </tr>
                    <tr>
                        <td>392</td>
                        <td>Japanese Yen (JPY)</td>
                    </tr>
                    <tr>
                        <td>398</td>
                        <td>Kazakh Tenge (KZT)</td>
                    </tr>
                    <tr>
                        <td>400</td>
                        <td>Jordanian Dinar (JOD)</td>
                    </tr>
                    <tr>
                        <td>404</td>
                        <td>Kenyan Shilling (KES)</td>
                    </tr>
                    <tr>
                        <td>410</td>
                        <td>South Korean Won (KRW)</td>
                    </tr>
                    <tr>
                        <td>414</td>
                        <td>Kuwaiti Dinar (KWD)</td>
                    </tr>
                    <tr>
                        <td>418</td>
                        <td>Laotian Kip (LAK)</td>
                    </tr>
                    <tr>
                        <td>426</td>
                        <td>Lesotho Loti (LSL)</td>
                    </tr>
                    <tr>
                        <td>430</td>
                        <td>Liberian Dollar (LRD)</td>
                    </tr>
                    <tr>
                        <td>446</td>
                        <td>Macanese Pataca (MOP)</td>
                    </tr>
                    <tr>
                        <td>454</td>
                        <td>Malawian Kwacha (MWK)</td>
                    </tr>
                    <tr>
                        <td>458</td>
                        <td>Malaysian Ringgit (MYR)</td>
                    </tr>
                    <tr>
                        <td>462</td>
                        <td>Maldivian Rufiyaa (MVR)</td>
                    </tr>
                    <tr>
                        <td>480</td>
                        <td>Mauritius Rupee (MUR)</td>
                    </tr>
                    <tr>
                        <td>484</td>
                        <td>Mexican Peso (MXN)</td>
                    </tr>

                    <tr>
                        <td>498</td>
                        <td>Moldovan Leu (MDL)</td>
                    </tr>
                    <tr>
                        <td>504</td>
                        <td>Moroccan Dirham (MAD)</td>
                    </tr>
                    <tr>
                        <td>512</td>
                        <td>Omani Rial (OMR)</td>
                    </tr>
                    <tr>
                        <td>516</td>
                        <td>Namibian Dollar (NAD)</td>
                    </tr>
                    <tr>
                        <td>524</td>
                        <td>Nepalese Rupee (NPR)</td>
                    </tr>
                    <tr>
                        <td>532</td>
                        <td>Netherlands Antillean Guilder (ANG)</td>
                    </tr>
                    <tr>
                        <td>533</td>
                        <td>Aruban Guilder (AWG)</td>
                    </tr>
                    <tr>
                        <td>548</td>
                        <td>Vanuatu Vatu (VUV)</td>
                    </tr>
                    <tr>
                        <td>554</td>
                        <td>New Zealand Dollar (NZD)</td>
                    </tr>
                    <tr>
                        <td>558</td>
                        <td>Nicaraguan Cordoba (NIO)</td>
                    </tr>
                    <tr>
                        <td>566</td>
                        <td>Nigerian Naira (NGN)</td>
                    </tr>
                    <tr>
                        <td>578</td>
                        <td>Norwegian Krone (NOK)</td>
                    </tr>
                    <tr>
                        <td>586</td>
                        <td>Pakistan Rupee (PKR)</td>
                    </tr>
                    <tr>
                        <td>598</td>
                        <td>Papua New Guinean Kina (PGK)</td>
                    </tr>
                    <tr>
                        <td>600</td>
                        <td>Paraguayan Guarani (PYG)</td>
                    </tr>
                    <tr>
                        <td>604</td>
                        <td>Peruvian Nuevo Sol (PEN)</td>
                    </tr>
                    <tr>
                        <td>608</td>
                        <td>Philippine Peso (PHP)</td>
                    </tr>
                    <tr>
                        <td>634</td>
                        <td>Qatari Rial (QAR)</td>
                    </tr>
                    <tr>
                        <td>643</td>
                        <td>Russian Ruble (RUB)</td>
                    </tr>
                    <tr>
                        <td>646</td>
                        <td>Rwandan Franc (RWF)</td>
                    </tr>
                    <tr>
                        <td>654</td>
                        <td>Saint Helena Pound (SHP)</td>
                    </tr>
                    <tr>
                        <td>682</td>
                        <td>Saudi Riyal (SAR)</td>
                    </tr>
                    <tr>
                        <td>690</td>
                        <td>Seychelles Rupee (SCR)</td>
                    </tr>

                    <tr>
                        <td>694</td>
                        <td>Sierra Leonean Leone (SLL)</td>
                    </tr>
                    <tr>
                        <td>702</td>
                        <td>Singapore Dollar (SGD)</td>
                    </tr>
                    <tr>
                        <td>704</td>
                        <td>Vietnamese Dong (VND)</td>
                    </tr>
                    <tr>
                        <td>710</td>
                        <td>South African Rand (ZAR)</td>
                    </tr>
                    <tr>
                        <td>748</td>
                        <td>Swaziland Lilangeni (SZL)</td>
                    </tr>
                    <tr>
                        <td>752</td>
                        <td>Swedish Krona (SEK)</td>
                    </tr>
                    <tr>
                        <td>756</td>
                        <td>Swiss Franc (CHF)</td>
                    </tr>
                    <tr>
                        <td>764</td>
                        <td>Thai Baht (THB)</td>
                    </tr>
                    <tr>
                        <td>780</td>
                        <td>{"Trinidad & Tobago Dollar (TTD)"}</td>
                    </tr>
                    <tr>
                        <td>784</td>
                        <td>UAE Dirham (AED)</td>
                    </tr>
                    <tr>
                        <td>788</td>
                        <td>Tunisian Dinar (TND)</td>
                    </tr>
                    <tr>
                        <td>800</td>
                        <td>Ugandan Shilling (UGX)</td>
                    </tr>
                    <tr>
                        <td>807</td>
                        <td>Macedonian Denar (MKD)</td>
                    </tr>
                    <tr>
                        <td>818</td>
                        <td>Egyptian Pound (EGP)</td>
                    </tr>
                    <tr>
                        <td>826</td>
                        <td>UK Pound Sterling (GBP)</td>
                    </tr>
                    <tr>
                        <td>834</td>
                        <td>Tanzanian Shilling (TZS)</td>
                    </tr>
                    <tr>
                        <td>840</td>
                        <td>US Dollar (USD)</td>
                    </tr>
                    <tr>
                        <td>858</td>
                        <td>Uruguayan Peso (UYU)</td>
                    </tr>
                    <tr>
                        <td>860</td>
                        <td>Uzbekistani Sum (UZS)</td>
                    </tr>
                    <tr>
                        <td>882</td>
                        <td>Samoan Tala (WST)</td>
                    </tr>
                    <tr>
                        <td>901</td>
                        <td>New Taiwan Dollar (TWD)</td>
                    </tr>
                    <tr>
                        <td>929</td>
                        <td>Mauritanian Ouguiya (MRU)</td>
                    </tr>
                    <tr>
                        <td>933</td>
                        <td>Belarusian Ruble (BYN)</td>
                    </tr>



                    <tr>
                        <td>934</td>
                        <td>Turkmenistan Manat (TMT)</td>
                    </tr>
                    <tr>
                        <td>941</td>
                        <td>Serbian Dinar (RSD)</td>
                    </tr>
                    <tr>
                        <td>943</td>
                        <td>Mozambique Metical (MZN)</td>
                    </tr>
                    <tr>
                        <td>944</td>
                        <td>Azerbaijani Manat (AZN)</td>
                    </tr>
                    <tr>
                        <td>946</td>
                        <td>Romanian New Leu (RON)</td>
                    </tr>
                    <tr>
                        <td>949</td>
                        <td>New Turkish Lira (TRY)</td>
                    </tr>
                    <tr>
                        <td>951</td>
                        <td>East Caribbean Dollar (XCD)</td>
                    </tr>
                    <tr>
                        <td>952</td>
                        <td>West African CFA Franc BCEAO (XOF)</td>
                    </tr>
                    <tr>
                        <td>953</td>
                        <td>CFP Franc (XPF)</td>
                    </tr>
                    <tr>
                        <td>967</td>
                        <td>Zambian Kwacha (ZMW)</td>
                    </tr>
                    <tr>
                        <td>968</td>
                        <td>Surinamese Dollar (SRD)</td>
                    </tr>
                    <tr>
                        <td>969</td>
                        <td>Malagasy Ariary (MGA)</td>
                    </tr>
                    <tr>
                        <td>971</td>
                        <td>Afghan Afghani (AFN)</td>
                    </tr>
                    <tr>
                        <td>972</td>
                        <td>Tajkistan Somoni (TJS)</td>
                    </tr>
                    <tr>
                        <td>973</td>
                        <td>Angola Kwanza (AOA)</td>
                    </tr>
                    <tr>
                        <td>975</td>
                        <td>Bulgarian Lev (BGN)</td>
                    </tr>
                    <tr>
                        <td>977</td>
                        <td>Bosnia and Herzegovina Convertible Mark (BAM)</td>
                    </tr>
                    <tr>
                        <td>978</td>
                        <td>Euro (EUR)</td>
                    </tr>
                    <tr>
                        <td>981</td>
                        <td>Georgian Lari (GEL)</td>
                    </tr>
                    <tr>
                        <td>985</td>
                        <td>Polish New Zloty (PLN)</td>
                    </tr>
                    <tr>
                        <td>986</td>
                        <td>Brazilian Real (BRL)</td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, ecrNumber } = state.mcp.main.config;
    return { mode, storeId, apiToken, ecrNumber, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {})(CurrencyCodes)
